module.exports = __webpack_public_path__ + "static/media/best-performing .a91e967b.svg";